module.exports = __webpack_public_path__ + "img/agengtmsg.002f6b51.png";